import * as React from "react";
import AccountingTable from "../common/AccountingTable3CE";
import { BankDetailConstants as Constants } from "../constants";

type EditableAccountLine = {
    label: string,
    amount: string,
    className: string,
    percent: string,
    edit: boolean
}

const Format : EditableAccountLine[] = [
    {"label":Constants.PROVEN_SUBROGATED,"amount":"0","percent": "0", "className":"","edit": true}, // 937667
    {"label":Constants.FILLER,"amount":Constants.FILLER, "percent": "", "className":"","edit":false},
    {"label":Constants.PROVEN_UNINSURED,"amount":"0","percent": "0", "className":"sumRow","edit":false},
    {"label":Constants.PROVEN_SUBTOTAL,"amount":"0","percent": "0", "className":"bold","edit":false},
    {"label":Constants.PROVEN_LESS,"amount":"0","percent": "0", "className":"sumRow","edit":false}
];

interface ProvenTableProps {
    subrogated: any;
    unisured: any;
    subTotal: any;
    dividendsPaid: any;
    total: any;
}

class ProvenTable extends React.Component<ProvenTableProps, any> {
    // eslint-disable-next-line
    constructor(props: ProvenTableProps) {
        super(props);
    }

    render() {
        let data : EditableAccountLine[] = Format;
        
       if( this.props.subrogated )
        {
            data[0].amount = this.props.subrogated[0] || "0";
            data[0].percent = this.props.subrogated[1] || "0";
            data[2].amount = this.props.unisured[0] || "0";
            data[2].percent = this.props.unisured[1] || "0";
            data[3].amount = this.props.subTotal[0] || "0";
            data[3].percent = this.props.subTotal[1] || "0";
            data[4].amount = this.props.dividendsPaid[0] || "0";
            data[4].percent = this.props.dividendsPaid[1] || "0";

        }

        return(
            <React.Fragment>
                <AccountingTable 
                    headers={Constants.PROVEN_HEADER} 
                    data={data} 
                    totalLabel={Constants.PROVEN_TOTAL}
                    totalAmount={this.props.total ? this.props.total[0] : ""}
                    totalPercent={this.props.total ? this.props.total[1] : ""}
                    idkey="subro"
                />
            </React.Fragment>
        )
    }
}

export default ProvenTable;